import { Component, OnInit } from "@angular/core";
import {MenuService} from "../../services/menu.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {

    title = "BEM-VINDO";

    constructor(public menuService: MenuService) {
    }

    ngOnInit(): void {
    }

}
